<template>
  <v-container>
    <v-layout row>
      <v-flex md3 pr-4 sm6 xs12>
        <v-text-field label="D/O NO" v-model="query.doNo"/>
      </v-flex>
      <v-flex md3 pr-4 sm6 xs12>
        <v-text-field label="MBLNO" v-model="query.masterBlNo"/>
      </v-flex>
      <v-flex md3 sm6 xs12>
        <v-text-field label="HBLNO" v-model="query.houseBlNo"/>
      </v-flex>
      <v-flex md2 sm6 xs12>
        <v-btn @click="innerSearch">検索</v-btn>
      </v-flex>
      <v-flex md2 sm6 xs12>
        <v-btn @click="close">戻る</v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="results"
      :pagination.sync="pagination"
      :rows-per-page-items="[10,25,50,100]"
      :total-items="pagination.totalItems"
      class="elevation-1"
      item-key="randomId"
      style="overflow-x:scroll"
    >
      <template slot="items" slot-scope="props">
        <td>
          <a @click="showAnalysisInfo(props.item.doNo)">{{ props.item.doNo }}</a>
        </td>
        <!-- <td>{{ props.item.doNo }}</td> -->
        <td>{{ props.item.masterBlNo }}</td>
        <td>{{ props.item.houseBlNo }}</td>
        <td
          style="text-align:right;"
          v-if="props.item.currencyCode === 'JPY'"
        >{{ props.item.taxed | currency({symbol:'',fractionCount:0}) }}</td>
        <td
          style="text-align:right;"
          v-if="props.item.currencyCode === 'JPY'"
        >{{ props.item.untaxed | currency({symbol:'',fractionCount:0}) }}</td>
        <td
          style="text-align:right;"
          v-if="props.item.currencyCode === 'JPY'"
        >{{ props.item.tax | currency({symbol:'',fractionCount:0}) }}</td>
        <td
          style="text-align:right;"
          v-if="props.item.currencyCode === 'JPY'"
        >{{ props.item.total | currency({symbol:'',fractionCount:0}) }}</td>
        <td
          style="text-align:right;"
          v-if="props.item.currencyCode !== 'JPY'"
        >{{ props.item.taxed | currency({symbol:'',fractionCount:2}) }}</td>
        <td
          style="text-align:right;"
          v-if="props.item.currencyCode !== 'JPY'"
        >{{ props.item.untaxed | currency({symbol:'',fractionCount:2}) }}</td>
        <td
          style="text-align:right;"
          v-if="props.item.currencyCode !== 'JPY'"
        >{{ props.item.tax | currency({symbol:'',fractionCount:2}) }}</td>
        <td
          style="text-align:right;"
          v-if="props.item.currencyCode !== 'JPY'"
        >{{ props.item.total | currency({symbol:'',fractionCount:2}) }}</td>
      </template>
      <template slot="footer">
        <td>DO総計{{ totalElements }}件</td>
        <td></td>
        <td>合計：</td>
        <td style="text-align:right;">{{ totalTaxedAmount | currency({symbol:'',fractionCount:2}) }}</td>
        <td
          style="text-align:right;"
        >{{ totalUntaxedAmount | currency({symbol:'',fractionCount:2}) }}</td>
        <td style="text-align:right;">{{ totalTaxAmount | currency({symbol:'',fractionCount:2}) }}</td>
        <td style="text-align:right;">{{ totalAmount | currency({symbol:'',fractionCount:2}) }}</td>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      totalElements: 0,
      query: {},
      headers: [
        // { text: '#', sortable: false },
        { text: 'DONo', sortable: false },
        { text: 'MBLNo', sortable: false },
        { text: 'HBLNo', sortable: false },
        { text: '課税金額', sortable: false, align: 'right' },
        { text: '非課税金額', sortable: false, align: 'right' },
        { text: '税金', sortable: false, align: 'right' },
        { text: '税込金額', sortable: false, align: 'right' }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      results: [],
      item: null,
      type: null,
      totalTaxedAmount: null,
      totalUntaxedAmount: null,
      totalTaxAmount: null,
      totalAmount: null
    }
  },
  methods: {
    search(item, type) {
      this.pagination.page = 0
      this.load(item, type)
    },
    innerSearch() {
      this.pagination.page = 0
      this.load(this.item, this.type)
    },
    load(item, type) {
      this.item = item
      this.type = type
      if (type === 'payment') {
        this.$http
          .get('/arap/finance/fee', {
            params: {
              ...{
                currencyCode: item.currencyKey,
                documentType: item.documentType,
                supplierName: item.supplierName,
                yearMonth: item.yearMonth,
                type: 'AP',
                doNo: this.query.doNo,
                masterBlNo: this.query.masterBlNo,
                houseBlNo: this.query.houseBlNo
              }
            }
          })
          .then(res => {
            this.totalTaxedAmount = res.data.taxed
            this.totalUntaxedAmount = res.data.untaxed
            this.totalTaxAmount = res.data.tax
            this.totalAmount = res.data.total
            console.log(res.data)
          })
        this.$http
          .get('/arap/finance/ap-detail', {
            params: {
              ...{
                currencyCode: item.currencyKey,
                documentType: item.documentType,
                supplierName: item.supplierName,
                yearMonth: item.yearMonth,
                doNo: this.query.doNo,
                masterBlNo: this.query.masterBlNo,
                houseBlNo: this.query.houseBlNo
              },
              ...this.$pageable()
            }
          })
          .then(res => {
            this.results = res.data.content
            this.pagination.page = res.data.number + 1
            this.pagination.rowsPerPage = res.data.size
            this.pagination.totalItems = res.data.totalElements
            this.totalElements = res.data.totalElements
          })
      } else if ((type = 'reqeust')) {
        this.$http
          .get('/arap/finance/fee', {
            params: {
              ...{
                currencyCode: item.currencyKey,
                documentType: item.documentType,
                divisionName: item.buName,
                yearMonth: item.yearMonth,
                type: 'AR',
                doNo: this.query.doNo,
                masterBlNo: this.query.masterBlNo,
                houseBlNo: this.query.houseBlNo
              }
            }
          })
          .then(res => {
            this.totalTaxedAmount = res.data.taxed
            this.totalUntaxedAmount = res.data.untaxed
            this.totalTaxAmount = res.data.tax
            this.totalAmount = res.data.total
            console.log(res.data)
          })
        this.$http
          .get('/arap/finance/ar-detail', {
            params: {
              ...{
                currencyCode: item.currencyKey,
                documentType: item.documentType,
                divisionName: item.buName,
                yearMonth: item.yearMonth,
                doNo: this.query.doNo,
                masterBlNo: this.query.masterBlNo,
                houseBlNo: this.query.houseBlNo
              },
              ...this.$pageable()
            }
          })
          .then(res => {
            this.results = res.data.content
            this.pagination.page = res.data.number + 1
            this.pagination.rowsPerPage = res.data.size
            this.pagination.totalItems = res.data.totalElements
            this.totalElements = res.data.totalElements
          })
      }
    },
    showAnalysisInfo(doNo) {
      this.$emit('showAnalysisInfo', doNo)
    },
    close() {
      this.query = {}
      this.$emit('closeDetail')
    }
  },

  computed: {},
  watch: {
    pagination() {
      if (this.item != null) {
        this.load(this.item, this.type)
      }
    }
  }
}
</script>